// extracted by mini-css-extract-plugin
module.exports = {"modalTermos":"style_modalTermos__rYhJ7","ant-modal-content":"style_ant-modal-content__2JwKh"};